import React from 'react';

import { DefaultContext } from '@apollo/client';

import { ActiveInactive, PeoPayrollProviderInfoFragment, PeoPayrollProviderUpdate } from 'src/api';
import { useNotification } from 'src/hooks/app';
import { RequestAutoAccept } from 'src/types/settingsForm';

import { EmployeeSettingsForm } from '../EmployeeSettingsForm';
import { SettingsFormFields, SettingsFormValues } from '../EmployeeSettingsForm/types';

interface PeoPayrollProviderSettingsFormProps {
  peoPayrollProvider: PeoPayrollProviderInfoFragment;
  updatePeoPayrollProvider: (params: {
    data: Omit<PeoPayrollProviderUpdate, 'id'>;
    context?: DefaultContext;
  }) => Promise<void>;
}

export const PeoPayrollProviderSettingsForm: React.FC<PeoPayrollProviderSettingsFormProps> = ({
  peoPayrollProvider,
  updatePeoPayrollProvider,
}) => {
  const { createApolloContext } = useNotification();

  const { signUpMethod } = peoPayrollProvider;

  const onSubmit = React.useCallback(
    async (data: SettingsFormValues) => {
      try {
        const defaultRequestAutoAccept =
          data.isAutoVerificationRequestEnabled === RequestAutoAccept.REQUIRED
            ? ActiveInactive.Active
            : ActiveInactive.Inactive;
        const { signUpMethod } = data;

        await updatePeoPayrollProvider({
          data: {
            defaultRequestAutoAccept,
            signUpMethod,
          },
          context: createApolloContext({
            successMessage: 'Changes are saved successfully',
          }),
        });
      } catch (error) {
        if (error instanceof Error) {
          console.error(error);
        } else {
          console.error(error);
        }
      }
    },
    [createApolloContext, updatePeoPayrollProvider],
  );

  const initialValues: SettingsFormValues = React.useMemo(
    () => ({
      [SettingsFormFields.signUpMethod]: signUpMethod,
    }),
    [signUpMethod],
  );

  return <EmployeeSettingsForm onSubmit={onSubmit} initialValues={initialValues} />;
};
